export default __webpack_public_path__ + "static/media/HK.298b318c.svg";